import React from "react";
import { Link, useLocation } from "react-router-dom";
import { unauthorized } from "../assets";

const Unauthorized = () => {
  const location = useLocation();
  const role = location.state?.role.toLowerCase();
  const allowedRole = location.state?.allowedRole;

  return (
    <section className="max-h-screen flex flex-col justify-center items-center gap-5 pb-10">
      <img src={unauthorized} className="object-contain" alt="" />
      <div className="text-center text-[20px] text-textSecondary">
        <p>
          You are trying to access
          {allowedRole?.map((role, i) => (
            <span key={i}> {role} </span>
          ))}
          resource. While logged in as {role}.
        </p>
        <p>
          Goto{" "}
          <Link
            className="border-secondary text-secondary border-b-2 font-bold"
            to={`/${role}/home`}
          >
            {role}'s
          </Link>{" "}
          page?
        </p>
      </div>
    </section>
  );
};

export default Unauthorized;
